import { Component, OnInit } from "@angular/core";
import { GlobalDataService } from "src/app/services/global-data.service";
import { ButtonIcon, IconPosition } from "../button/button.component";
import { Icon } from "../icons/svg-icon.component";
import { ModalController } from "@ionic/angular";

@Component({
  selector: "app-mappedin",
  templateUrl: "./mappedin.component.html",
  styleUrls: ["./mappedin.component.scss"],
})
export class MappedinComponent implements OnInit {
  popupView: boolean = false;
  mapsEnabled: boolean = false;
  modalCloseIcon: ButtonIcon = {
    name: Icon.Close,
    position: IconPosition.RIGHT,
  }

  constructor(private globalData: GlobalDataService, private modalCtrl: ModalController) {
    this.globalData.dataChange.subscribe((value) => {
      if (value.general.mapsEnabled) {
        if (typeof window !== "undefined")
          window.mappedin = { ...value.general.mapsConfig };
        this.mapsEnabled = value.general.mapsEnabled;
      }
    });
  }

  ngOnInit() {
    const initialMallData = this.globalData.getGlobalData();
    if (initialMallData?.general?.mapsEnabled) {
      if (typeof window !== "undefined")
        window.mappedin = { ...initialMallData.general.mapsConfig };
      this.mapsEnabled = initialMallData.general.mapsEnabled;
    }
  }

  async closeModal() {
    await this.modalCtrl.dismiss();
  }
}
